import Page, { getStaticProps as compGetStaticProps } from 'components/pages/Regulations';

export const getStaticProps = compGetStaticProps;
export default Page;
